import { ComposedChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, Area } from 'recharts';
import React, { useEffect, useState } from "react";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import TextField from '@mui/material/TextField';
import Moment from 'react-moment';
import moment from 'moment';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import MobileDateTimePicker from '@mui/lab/MobileDateTimePicker'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DetectorDetails from '../../detectors/DetectorDetails';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AuthService from "../../services/auth.service";
import { useParams } from "react-router-dom";
import generatePDFParking from '../../services/reportGeneratorParking';
import BeatLoader from "react-spinners/BeatLoader";
import authHeader from "../../services/auth-header";

import useWindowDimensions from './windowDimensions';

import { useTranslation } from "react-i18next";

const api = require("../../api/names.js");//const data = [{name: 'Page A', uv: 400, pv: 300, amt: 2400},{name: 'Page B', uv: 100, pv: 2400, amt: 2400},{name: 'Page C', uv: 150, pv: 2400, amt: 2400},{name: 'Page D', uv: 0, pv: 2400, amt: 2400}];

var p_stats = {};

function HistoryChart(props)
{
  const { t } = useTranslation("common");

  const [currentUser, setCurrentUser] = useState(true);
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);
  const [dateMin, setDateMin] = useState(new Date(Date.now() - (7*24*60*60*1000)));
  const [dateMax, setDateMax] = useState(new Date());
  const [itemsStateChanged, setItemsStateChanged] = useState([]);
  const [generating, setGenerating] = useState(0);

  //battery,frametype,isBusy,radar,stateChange,temperature,x,y,counter,dataRate,frequency,rssi,snr
  const [batteryIsChecked, batterySetIsChecked] = useState(false);
  const [frametypeIsChecked, frametypeSetIsChecked] = useState(false);
  const [isBusyIsChecked, isBusySetIsChecked] = useState(true);
  const [radarIsChecked, radarSetIsChecked] = useState(false);
  const [stateChangeIsChecked, stateChangeSetIsChecked] = useState(false);
  const [temperatureIsChecked, temperatureSetIsChecked] = useState(false);
  const [xIsChecked, xSetIsChecked] = useState(false);
  const [yIsChecked, ySetIsChecked] = useState(false);
  const [counterIsChecked, counterSetIsChecked] = useState(false);
  const [dataRateIsChecked, dataRateSetIsChecked] = useState(false);
  const [frequencyIsChecked, frequencySetIsChecked] = useState(false);
  const [rssiIsChecked, rssiSetIsChecked] = useState(false);
  const [snrIsChecked, snrSetIsChecked] = useState(false);
  const [normalize, setNormalize] = useState(false);


  const batteryHandleOnChange = () => {
    batterySetIsChecked(!batteryIsChecked);
  };
  const frametypeHandleOnChange = () => {
    frametypeSetIsChecked(!frametypeIsChecked);
  };
  const isBusyHandleOnChange = () => {
    isBusySetIsChecked(!isBusyIsChecked);
  };
  const radarHandleOnChange = () => {
    radarSetIsChecked(!radarIsChecked);
  };
  const stateChangeHandleOnChange = () => {
    stateChangeSetIsChecked(!stateChangeIsChecked);
  };
  const temperatureHandleOnChange = () => {
    temperatureSetIsChecked(!temperatureIsChecked);
  };
  const xHandleOnChange = () => {
    xSetIsChecked(!xIsChecked);
  };
  const yHandleOnChange = () => {
    ySetIsChecked(!yIsChecked);
  };
  const counterHandleOnChange = () => {
    counterSetIsChecked(!counterIsChecked);
  };
  const dataRateHandleOnChange = () => {
    dataRateSetIsChecked(!dataRateIsChecked);
  };
  const frequencyHandleOnChange = () => {
    frequencySetIsChecked(!frequencyIsChecked);
  };
  const rssiHandleOnChange = () => {
    rssiSetIsChecked(!rssiIsChecked);
  };
  const snrHandleOnChange = () => {
    snrSetIsChecked(!snrIsChecked);
  };
  const normalizeOnChange = () => {
    setNormalize(!normalize);
  };

  const params = useParams();
  console.log(params);
  useEffect(() => {
    const user = AuthService.getCurrentUser();
    if (user) {
      setCurrentUser(user);
    }
    loadHistoryData(dateMin, dateMax, params.address);

  },[dateMin, dateMax, params.address])

function loadHistoryData(dMax, dMin, addr)
{
  var url = api.baseUrl+'/detectorsHistoryValues/byAddress/';
  url += addr;
  url += "/";
  url += dMax.getTime();
  url += "/";
  url += dMin.getTime();
  console.log(url);

  fetch(url, {
method: 'get',
headers: authHeader()
})
  .then(res => res.json())
  .then(
    (result) => {
      setIsLoaded(true);
      setItems(result);
      setItemsStateChanged(result.filter(item => item.stateChange === 1));
    },
    (error) => {
      setIsLoaded(true);
      setError(error);
    }
  )
}

function LoadDefaultHistoryData(addr)
{
  var url = api.baseUrl+'/detectorsHistoryValues/byAddress/';
  //var url = api.baseUrl+'/detectorsCurrentValues/WithMetadataByAddress/';
  var dateNow = new Date();
  url += addr;
  url += "/";
  url += "0";
  url += "/";
  url += dateNow.getTime();
  //console.log(url);
  
  fetch(url, {
method: 'get',
headers: authHeader()
})
  .then(res => res.json())
  .then(
    (result) => {
      setIsLoaded(true);
      setItems(result);

    },
    (error) => {
      setIsLoaded(true);
      setError(error);
    }
  )
}

  function changeGenerating(){

    setGenerating(1);
    setTimeout(() => {
      setGenerating(0);
    }, 2000);
  };


  const columns = [
    { field: 'address', headerName: t('charttable.id'), width: 90 },
  /*  { field: 'radar', headerName: 'radar', width: 90 },
    { field: 'x', headerName: 'x', width: 90 },
    { field: 'y', headerName: 'y', width: 90 },
    { field: 'battery', headerName: 'battery', width: 90 },*/
    { field: 'isBusy', headerName: t('charttable.busy.1'), width: 90 },
  /*  { field: 'temperature', headerName: 'temperature', width: 90 },
    { field: 'timestamp', headerName: 'Ostatni status (timestamp)', width: 90 },
    { field: 'frameType', headerName: 'frameType', width: 90 },
    { field: 'stateChange', headerName: 'stateChange', width: 90 },
    { field: 'rssi', headerName: 'rssi', width: 90 },
    { field: 'sf', headerName: 'sf', width: 90 },*/
  //  { field: 'snr', headerName: 'snr', width: 90 },
    //{ field: 'counter', headerName: 'counter', width: 90 },
    { field: 'updatedAt', headerName: t('charttable.laststatus'), width: 300 }

  ];

  function seconds2time (seconds) {
      var hours   = Math.floor(seconds / 3600);
      var minutes = Math.floor((seconds - (hours * 3600)) / 60);
      seconds = seconds - (hours * 3600) - (minutes * 60);
      var time = "";

      if (hours !== 0) {
        time = hours+"h ";
      }
      if (minutes !== 0 || time !== "") {
        minutes = (minutes < 10 && time !== "") ? "0"+minutes : String(minutes);
        time += minutes+"min ";
      }
      if (time === "") {
        time = seconds+"s";
      }
      else {
        time += (seconds < 10) ? "0"+seconds : String(seconds)+"s";
      }
      return time;
  }

function loadStatistics() {
  var i=0;
  var arrayWolne = {};
  var arrayZajete = {};

var stats = {};
var detectorsDurations = []
var entriesExitsByHours = []
stats.detectorsDurations = detectorsDurations;

  for(i=1;i<itemsStateChanged.length;i++)
  {

    var t1 = itemsStateChanged[i - 1].timestamp / 1000;
    var t2 = itemsStateChanged[i].timestamp / 1000;

    var duration = Math.round(itemsStateChanged[i].timestamp/1000 - itemsStateChanged[i-1].timestamp/1000);
    /*if(duration < 0)
    {
      duration = -1*duration;
    }*/

    if(itemsStateChanged[i].isBusy === 1 && duration > 0)
    {

      let detectorDuration = {
        "id": i,
        "duration": duration,
        "start": t1,
        "stop": t2,
        "type": "wolny"
      }
      stats.detectorsDurations.push(detectorDuration);
      //jsonData['duration'] = 15;//itemsStateChanged[i].timestamp/1000 - itemsStateChanged[i-1].timestamp/1000;
      //console.log(arrayWolne);
      //arrayWolne.push(jsonData);
      //console.log("Wolny: "+(itemsStateChanged[i].timestamp - itemsStateChanged[i-1].timestamp).toString());

      //arrayWolne.push({id: 1, duration: (itemsStateChanged[i].timestamp/1000 - itemsStateChanged[i-1].timestamp/1000)});

      let entriesExits = {
        "id": i,
        "duration": seconds2time(duration),
        "start": moment.unix(t1).format("HH:mm:ss - DD/MM/YYYY"),
        "stop": moment.unix(t2).format("HH:mm:ss - DD/MM/YYYY"),
        "type": "wolny"
      }
      entriesExitsByHours.push(entriesExits);
    }
    else if(itemsStateChanged[i].isBusy === 0 && duration > 0) {

      let detectorDuration = {
        "id": i,
        "duration": duration,
        "start": t1,
        "stop": t2,
        "type": "zajety"
      }
      stats.detectorsDurations.push(detectorDuration);
      //console.log("Zajety: "+(itemsStateChanged[i].timestamp - itemsStateChanged[i-1].timestamp).toString());
      //arrayZajete.push({id: 2, duration: (itemsStateChanged[i].timestamp/1000 - itemsStateChanged[i-1].timestamp/1000)});
      //jsonData['duration'] = itemsStateChanged[i].timestamp/1000 - itemsStateChanged[i-1].timestamp/1000;
      //arrayZajete.push(jsonData);
      let entriesExits = {
        "id": i,
        "duration": seconds2time(duration),
        "start": moment.unix(t1).format("HH:mm:ss - DD/MM/YYYY"),
        "stop": moment.unix(t2).format("HH:mm:ss - DD/MM/YYYY"),
        "type": "zajety"
      }
      entriesExitsByHours.push(entriesExits);
    }




  }
  //console.log(stats);
  arrayWolne = stats.detectorsDurations.filter(item => item.type === "wolny");
  arrayZajete = stats.detectorsDurations.filter(item => item.type === "zajety");


  //console.log(arrayWolne);
  console.log(arrayZajete);
  var maxZajete = Math.max.apply(Math, arrayZajete.map(function(o) { return o.duration; }));
  var minZajete = Math.min.apply(Math, arrayZajete.map(function(o) { return o.duration; }));
  if(minZajete < 0)
  {
    minZajete = 1;
  }
  //var sumZajete = Math.sum.apply(Math, arrayZajete.map(function(o) { return o.duration; }));

  //const sumZajete = arrayZajete => arrayZajete.reduce((a,b) => a + b, 0)
  //var avgZajete = sumZajete/(arrayZajete.length);
  var sumZajete = arrayZajete.reduce(function(_this, val) {
          return _this + val.duration
      }, 0);

  var sumWolne = arrayWolne.reduce(function(_this, val) {
              return _this + val.duration
          }, 0);
  var percentageZajete = ((sumZajete/(sumWolne+sumZajete))*100).toFixed(2);
  var percentageWolne = ((sumWolne/(sumWolne+sumZajete))*100).toFixed(2);
  const avgZajete = Math.round((sumZajete / arrayZajete.length) || 0);

  var maxWolne = Math.max.apply(Math, arrayWolne.map(function(o) { return o.duration; }));
  var minWolne = Math.min.apply(Math, arrayWolne.map(function(o) { return o.duration; }));
  if(minWolne < 0)
  {
    minWolne = 1;
  }


  var parkingStats = []
  p_stats.chart = 'div2PDF1';
  p_stats.id = 2;
  p_stats.deviceId = params.address;
  p_stats.parkingStats = parkingStats;
  console.log(p_stats);

  var data = {
    "dateMin": dateMin,
    "dateMax": dateMax,
    "ilePojazdow": arrayZajete.length,
    "sredniCzasParkowania": seconds2time(avgZajete),
    "procentWolne": percentageWolne + '%',
    "procentZajete": percentageZajete + '%',
    "minWolne": seconds2time(minWolne),
    "maxWolne": seconds2time(maxWolne),
    "minZajete": seconds2time(minZajete),
    "maxZajete": seconds2time(maxZajete),
    "allEntries": itemsStateChanged,
    "entriesExitsByHours": entriesExitsByHours

  }
  p_stats.parkingStats.push(data);
  console.log(p_stats);


  return(
    <div>
    <TableContainer component={Paper}>
     <Table sx={{ minWidth: 650 }} aria-label="simple table">
       <TableHead>
          <TableRow>
           <TableCell>{t('charttable.parkingcount')}</TableCell>
           <TableCell>{t('charttable.avgparktime')}</TableCell>
            <TableCell>% {t('charttable.free.2')}</TableCell>
            <TableCell >% {t('charttable.busy.2')}</TableCell>
            <TableCell>Min {t('charttable.free.2')}</TableCell>
            <TableCell>Max {t('charttable.free.2')}</TableCell>
            <TableCell >Min {t('charttable.busy.2')}</TableCell>
            <TableCell >Max {t('charttable.busy.2')}</TableCell>
         </TableRow>
       </TableHead>
       <TableBody>
          <TableRow>
            <TableCell >{arrayZajete.length}</TableCell>
            <TableCell >{seconds2time(avgZajete)}</TableCell>
            <TableCell >{percentageWolne}%</TableCell>
            <TableCell >{percentageZajete}%</TableCell>
            <TableCell >{seconds2time(minWolne)}</TableCell>
             <TableCell >{seconds2time(maxWolne)}</TableCell>
             <TableCell >{seconds2time(minZajete)}</TableCell>
             <TableCell >{seconds2time(maxZajete)}</TableCell>


           </TableRow>

       </TableBody>
     </Table>
   </TableContainer>


    <TableContainer component={Paper}>
     <Table sx={{ minWidth: 650 }} aria-label="simple table">
       <TableHead>
          <TableRow>
          <TableCell>ID</TableCell>
           <TableCell>{t('parkingstats.duration')}</TableCell>
           <TableCell >{t('charttable.description')}</TableCell>
           <TableCell >Start</TableCell>
           <TableCell >Stop</TableCell>
         </TableRow>
       </TableHead>
       <TableBody>
         {stats.detectorsDurations.map(item => (
           <TableRow
             key={item.id}
             sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
           >
            <TableCell >{item.id}</TableCell>
             <TableCell >{seconds2time(item.duration)}</TableCell>
             <TableCell >{item.type}</TableCell>
             <TableCell ><Moment format="HH:mm:ss - DD/MM/YYYY" unix>{item.start}</Moment></TableCell>
             <TableCell ><Moment format="HH:mm:ss - DD/MM/YYYY" unix>{item.stop}</Moment></TableCell>

           </TableRow>
         ))}
       </TableBody>
     </Table>
   </TableContainer>
    </div>

  )

}

function LineChartConditional() {
  const {height,width} = useWindowDimensions();

  var data = [];

  const Cmin = Math.min(...items.map(o => o.counter));
  const Cmax = Math.max(...items.map(o => o.counter));
  const Rmin = Math.min(...items.map(o => o.radar));
  const Rmax = Math.max(...items.map(o => o.radar));

  const length = items.length
  if(normalize){
    for(var i = 0; i<length; i++){
      var normalizedBattery;
      if (items[i].battery != null)
        normalizedBattery = items[i].battery / 0xFF + 0.6;
      else
        normalizedBattery = null;

      var normalizedRadar;
      if (items[i].radar != null)
        normalizedRadar = (items[i].radar - Rmin) / (Rmax - Rmin) + 0.6;
      else
        normalizedRadar = null;

      var normalizedTemperature;
      if (items[i].temperature != null)
        normalizedTemperature = items[i].temperature / 200 + 0.9;
      else
        normalizedTemperature = null;

      var normalizedX;
      if (items[i].x != null)
        normalizedX = items[i].x/ 0xFFF + 0.6;
      else
        normalizedX = null;

      var normalizedY;
      if (items[i].y != null)
        normalizedY = items[i].y/ 0xFFF + 0.6;
      else
        normalizedY = null;

      var normalizedCounter;
      if (items[i].counter != null)
        normalizedCounter = (items[i].counter-Cmin) / (Cmax-Cmin)+ 0.6;
      else
        normalizedCounter = null;

      var normalizedRssi;
      if (items[i].rssi != null)
        normalizedRssi = items[i].rssi / 100 + 1.6;
      else
        normalizedRssi = null;

      var normalizedSnr;
      if (items[i].snr != null)
        normalizedSnr = items[i].snr / 40 + 1.1;
      else
        normalizedSnr = null;

      var normalizedFrametype;
      if (items[i].frameType != null)
        normalizedFrametype = items[i].frameType / 21 + 0.6;
      else
        normalizedFrametype = null;

      var normalizedRecord = {
        "timestamp": items[i].timestamp,
        "battery": normalizedBattery,
        "isBusy": items[i].isBusy/2,
        "radar": normalizedRadar,
        "temperature": normalizedTemperature,
        "x": normalizedX,
        "y": normalizedY,
        "counter": normalizedCounter,
        "rssi": normalizedRssi,
        "snr": normalizedSnr,
        "frameType": normalizedFrametype
      }
      data.push(normalizedRecord);
    }
  }
  else{
    data = items;
  }

  return(
    <ComposedChart width={width-40} height={height-20} data={data} margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>

    <YAxis domain={['auto', 'dataMax + 0.1']}/>

    <XAxis interval={"preserveEnd"} domain={['dataMin', 'dataMax']} name = 'Time' dataKey="timestamp" tickFormatter={(unixTime) => moment(unixTime).format('DD.MM:HH')} type='number' />

    {batteryIsChecked &&
    <Line type="stepAfter" dataKey="battery"  stroke="olive" strokeWidth={1} dot={false} activeDot={{ stroke: 'blue', strokeWidth: 2, r: 2 }}/>
    }
    {frametypeIsChecked &&
    <Line type="stepAfter" dataKey="frameType"  stroke="orange" strokeWidth={1} dot={false} activeDot={{ stroke: 'blue', strokeWidth: 2, r: 2 }}/>
    }
    {isBusyIsChecked &&
    <Area type="stepAfter" dataKey="isBusy" fill="magenta"  stroke="magenta" strokeWidth={1} dot={false} activeDot={{ stroke: 'blue', strokeWidth: 2, r: 2 }}/>
    }
    {radarIsChecked &&
    <Line type="stepAfter" dataKey="radar"  stroke="red" strokeWidth={1} dot={false} activeDot={{ stroke: 'blue', strokeWidth: 2, r: 2 }}/>
    }
    {stateChangeIsChecked &&
    <Line type="stepAfter" dataKey="stateChenge"  stroke="peru" strokeWidth={1} dot={false} activeDot={{ stroke: 'blue', strokeWidth: 2, r: 2 }}/>
    }
    {temperatureIsChecked &&
    <Line type="basis" dataKey="temperature"  stroke="brown" strokeWidth={1} dot={false} activeDot={{ stroke: 'blue', strokeWidth: 2, r: 2 }}/>
    }
    {xIsChecked &&
    <Line type="stepAfter" dataKey="x"  stroke="navy" strokeWidth={1} dot={false} activeDot={{ stroke: 'blue', strokeWidth: 2, r: 2 }}/>
    }
    {yIsChecked &&
    <Line type="stepAfter" dataKey="y"  stroke="black" strokeWidth={1} dot={false} activeDot={{ stroke: 'blue', strokeWidth: 2, r: 2 }}/>
    }
    {counterIsChecked &&
    <Line type="stepAfter" dataKey="counter"  stroke="lime" strokeWidth={1} dot={false} activeDot={{ stroke: 'blue', strokeWidth: 2, r: 2 }}/>
    }
    {dataRateIsChecked &&
    <Line type="stepAfter" dataKey="dataRate"  stroke="black" strokeWidth={1} dot={false} activeDot={{ stroke: 'blue', strokeWidth: 2, r: 2 }}/>
    }
    {frequencyIsChecked &&
    <Line type="stepAfter" dataKey="frequency"  stroke="black" strokeWidth={1} dot={false} activeDot={{ stroke: 'blue', strokeWidth: 2, r: 2 }}/>
    }
    {rssiIsChecked &&
    <Line type="stepAfter" dataKey="rssi"  stroke="green" strokeWidth={1} dot={false} activeDot={{ stroke: 'blue', strokeWidth: 2, r: 2 }}/>
    }
    {snrIsChecked &&
    <Line type="stepAfter" dataKey="snr"  stroke="green" strokeWidth={1} dot={false} activeDot={{ stroke: 'blue', strokeWidth: 2, r: 2 }}/>
    }
    <CartesianGrid stroke="#ccc" strokeDasharray="10 10" />
    {normalize ? (< Tooltip
      formatter={(value, name) => {
        switch(name)
        {
          case "isBusy": return `${Math.round(value * 2)}`;
          case "radar": return `${Math.round((value - 0.6) * (Rmax-Rmin)+Rmin)}`;
          case "battery": return `${Math.round((value-0.6)*0xFF)}`;
          case "temperature": return `${Math.round((value - 0.9) * 200)}`;
          case "x": return `${Math.round((value - 0.6) * 0xFFF)}`;
          case "y": return `${Math.round((value - 0.6) * 0xFFF)}`;
          case "counter": return `${Math.round((value - 0.6) * (Cmax-Cmin)+Cmin)}`;
          case "rssi": return `${Math.round((value - 1.6) * 100)}`;
          case "snr": return `${Math.round((value - 1.1) * 400)/10}`;
          case "frameType": return `${Math.round((value - 0.6) * 21)}`;
          default: return value.toLocaleString();
        }
      }}
      labelFormatter={t => moment.unix(t / 1000).format("HH:mm:ss - DD/MM/YYYY")} />) :
    (<Tooltip labelFormatter={t => moment.unix(t/1000).format("HH:mm:ss - DD/MM/YYYY")} />)}
    </ComposedChart>
  )
};

if (error) {
  return <div>{t('detectord.error')}{error.message}</div>;
 } else if (!isLoaded) {
  return <div>{t('detectord.loading')}</div>;
 } else {
  return(

    <div >
      {/*<div className="App">*/}
    <br/>
      <Button href={'/parkingDetails/' + params.parkingID} variant="outlined" startIcon={<ArrowBackIcon />} style={{ pos: 'left' }}>
        {t('charttable.comeback')}
      </Button>

      <button
        className="btn btn-primary"
        onClick={() => { changeGenerating(); generatePDFParking(p_stats) }}
        disabled={generating}>
        <BeatLoader loading={generating} size={15} color= '#FFFFFF'/>
        {generating ? (t('parkingstats.generating')) : (t('parkingstats.report'))}
      </button>
    <br/>
    <br/>
    <LocalizationProvider dateAdapter={AdapterDateFns}>
    <MobileDateTimePicker
          ampm={false}
          ampmInClock={false}
          value= {dateMin}
          onChange={(newValue) => {
            setDateMin(newValue);
            console.log(dateMin);
            console.log(dateMin.getTime());

            }}
          label={t('parkingstats.begin')}
          onError={console.log}
          minDate={new Date('2018-01-01T00:00')}
          inputFormat="yyyy/MM/dd HH:mm"
          mask="___/__/__ __:__ _M"
          renderInput={(params) => <TextField {...params} />}
        />

        <MobileDateTimePicker
              ampm={false}
              ampmInClock={false}
              value={dateMax}
                onChange={(newValue) => {
                    setDateMax(newValue);
                    //
                    }}
              label={t('parkingstats.end')}
              onError={console.log}
              minDate={new Date('2018-01-01T00:00')}
              inputFormat="yyyy/MM/dd HH:mm"
              mask="___/__/__ __:__ _M"
              renderInput={(params) => <TextField {...params} />}
            />


   </LocalizationProvider>
   <Button
  onClick={() => {
    loadHistoryData(dateMin, dateMax, params.address);
  }}
>
        {t('charttable.loaddata')}
</Button>
<Button
onClick={() => {
 LoadDefaultHistoryData(params.address);
}}
>
        {t('charttable.resetdata')}
</Button>
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel2a-content"
        id="panel2a-header"
      >
          <Typography>{t('charttable.sensor')}</Typography>
      </AccordionSummary>
      <AccordionDetails>
      <DetectorDetails address={params.address}/>

      </AccordionDetails>
    </Accordion>
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel2a-content"
        id="panel2a-header"
      >
          <Typography>{t('charttable.statistics')}</Typography>
      </AccordionSummary>
      <AccordionDetails>

      {loadStatistics()}


      </AccordionDetails>
    </Accordion>

<Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel2a-content"
        id="panel2a-header"
      >
          <Typography>{t('charttable.chart')}</Typography>
      </AccordionSummary>
      <AccordionDetails>
      <div className="App">
          {t('charttable.selectdata')}

      <div className="topping">
            <input type="checkbox" id="topping" name="topping" value="battery" checked={batteryIsChecked} onChange={batteryHandleOnChange} /><label for="battery">{t('charttable.battery')}</label>
            <input type="checkbox" id="topping" name="topping" value="isBusy" checked={isBusyIsChecked} onChange={isBusyHandleOnChange} /><label for="isBusy">{t('charttable.busy.3')}</label>
        {currentUser.id === 4 && (<input type="checkbox" id="topping" name="topping" value="radar"  checked={radarIsChecked} onChange={radarHandleOnChange} />)}{currentUser.id === 4 && (<label for="radar">radar</label>)}
        {currentUser.id === 4 && (<input type="checkbox" id="topping" name="topping" value="stateChange"  checked={stateChangeIsChecked} onChange={stateChangeHandleOnChange} />)}{currentUser.id === 4 && (<label for="stateChange">stateChange</label>)}
        {currentUser.id === 4 && (<input type="checkbox" id="topping" name="topping" value="temperature"  checked={temperatureIsChecked} onChange={temperatureHandleOnChange} />)}{currentUser.id === 4 && (<label for="temperature">temperature</label>)}
        {currentUser.id === 4 && (<input type="checkbox" id="topping" name="topping" value="x"  checked={xIsChecked} onChange={xHandleOnChange} />)}{currentUser.id === 4 && (<label for="x">x</label>)}
        {currentUser.id === 4 && (<input type="checkbox" id="topping" name="topping" value="y"  checked={yIsChecked} onChange={yHandleOnChange} />)}{currentUser.id === 4 && (<label for="y">y</label>)}
        {currentUser.id === 4 && (<input type="checkbox" id="topping" name="topping" value="counter"  checked={counterIsChecked} onChange={counterHandleOnChange} />)}{currentUser.id === 4 && (<label for="counter">counter</label>)}
        {currentUser.id === 4 && (<input type="checkbox" id="topping" name="topping" value="dataRate"  checked={dataRateIsChecked} onChange={dataRateHandleOnChange} />)}{currentUser.id === 4 && (<label for="dataRate">dataRate</label>)}
        {currentUser.id === 4 && (<input type="checkbox" id="topping" name="topping" value="frequency"  checked={frequencyIsChecked} onChange={frequencyHandleOnChange} />)}{currentUser.id === 4 && (<label for="frequency">frequency</label>)}
        {currentUser.id === 4 && (<input type="checkbox" id="topping" name="topping" value="rssi"  checked={rssiIsChecked} onChange={rssiHandleOnChange} />)}{currentUser.id === 4 && (<label for="rssi">rssi</label>)}
        {currentUser.id === 4 && (<input type="checkbox" id="topping" name="topping" value="snr"  checked={snrIsChecked} onChange={snrHandleOnChange} />)}{currentUser.id === 4 && (<label for="snr">snr</label>)}
        {currentUser.id === 4 && (<input type="checkbox" id="topping" name="topping" value="frametype"  checked={frametypeIsChecked} onChange={frametypeHandleOnChange} />)}{currentUser.id === 4 && (<label for="frametype">frametype</label>)}
            <input type="checkbox" id="topping" name="topping" value="normalize" checked={normalize} onChange={normalizeOnChange}/><label for="normalize">{t('charttable.normalize')}</label>
      </div>
      </div>

    <LineChartConditional/>
      </AccordionDetails>
    </Accordion>





    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel2a-content"
        id="panel2a-header"
      >
        <Typography>{t('charttable.historicaldata')}</Typography>
      </AccordionSummary>
      <AccordionDetails>
      <div style={{ height: 1000, width: '100%' }}>
   <DataGrid

     rows={items}
     columns={columns}
     pageSize={100}
     rowsPerPageOptions={[10]}
     checkboxSelection
     disableSelectionOnClick
     localeText={{
       toolbarColumns: t('gridtoolbar.columns'),
       toolbarFilters: t('gridtoolbar.filters'),
       toolbarDensity: t('gridtoolbar.density'),
       toolbarExport: t('gridtoolbar.export')
     }}
     components={{
       Toolbar: GridToolbar,
     }}
   />
 </div>
      </AccordionDetails>
    </Accordion>
      <div id="div2PDF1" style={{ display: "none" }} >
        <LineChartConditional/>
      </div>









</div>
);
 }
};
export default HistoryChart;
